
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton } from '@/components';
import { useTournamentLeaderboardAdd } from '@/modules/tournament/leaderboard/model/add';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';

export default defineComponent({
    name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.ADD,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton },
    setup() {
        const { model, v$, create } = useTournamentLeaderboardAdd();

        return { v$, model, create, timeUnits };
    }
});
